import { Controller } from '@hotwired/stimulus';
import { getContentType } from 'lib/helpers';
import { displaySearchPopup } from 'lib/partner-popup-helpers';
import { incrementSearchCount } from 'lib/search-helpers';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { TRENDING_CLICK } from 'components/analytics/conversions/constants/actions';

export default class TrendingSearchesController extends Controller {
  trackTrendingSearch = (event) => {
    sendTrackingEvent({
      element: event.target,
      data: {
        action: TRENDING_CLICK,
        label: `Terms-${event.currentTarget.textContent}`,
        content_type: `Content-${getContentType()}`,
      },
    });

    displaySearchPopup({ searchTerm: event.currentTarget.textContent });
    incrementSearchCount();
  }
}
